export const RULES_AND_REGULATION_URL_VIDEO = 'https://www.youtube.com/embed/hLPK-FIUBRY';
export const COMPANY_INFORMATION_URL_VIDEO = 'https://www.youtube.com/embed/jehI92ZuWn0?si=_niVedWFi2HIWv4d';
export const TRADE_DATA_URL_VIDEO = 'https://www.youtube.com/embed/DD8ndAbwwqg?si=3RmWDAWo5uzrtfS_';
export const PEOPLE_URL_VIDEO = 'https://www.youtube.com/embed/2hA8VfmxOr0?si=zrwh1zDBdC0b3C_z'
export const PORT_URL_VIDEO = "https://www.youtube.com/embed/SMPJ0bfCQ9g?si=AOJ3kGvTj1VbY3XA"
export const VESSEL_URL_VIDEO = "https://www.youtube.com/embed/nawR5xq5Fmo?si=NyJ_AoMGddHKG6Rd"
export const AI_LABELING_URL_VIDEO = "https://www.youtube.com/embed/alGcH0OlKjQ?si=mJZU5JIesKfPyj6N" 
